import { literal, object, string, union } from 'zod';

import { validateYoutubeUrl } from '@/views/build/util/youtubeUrlValidator';

export const HINT_REQUIRED_MESSAGE = 'Hint is required';
export const YOUTUBE_HINT_INVALID_MESSAGE = 'Invalid YouTube URL' as const;

export const YOUTUBE_HINT_REGEX =
  /^(https?:\/\/)?(www\.)?(youtube\.com\/(watch\?v=|embed\/|v\/|shorts\/)|youtu\.be\/)[\w-]{11}(\S*)?$/;

export const QuizHintSchema = object({
  type: union([literal('text'), literal('image'), literal('youtube')]),
  value: string().min(1, HINT_REQUIRED_MESSAGE),
}).refine(
  data => {
    if (data.type === 'youtube') {
      const result = validateYoutubeUrl(data.value);
      return result.isValid;
    }
    return true; // text나 image 타입은 통과
  },
  {
    message: YOUTUBE_HINT_INVALID_MESSAGE,
  },
);

export const validateHint = (hint: Zod.infer<typeof QuizHintSchema>) => {
  const result = QuizHintSchema.safeParse(hint);
  return result;
};
